import { useMutation, useQueryClient } from '@tanstack/react-query';

import { postRedeemCode } from '@arrived/api_v2';
import { RedeemCodeResponse, ReferralCode } from '@arrived/models';

import { UseMutationOptions } from '../queries.utils';
import { referralsQueryKeyFn } from './referrals.keys';

export function usePostRedeemCodeMutation(options?: UseMutationOptions<RedeemCodeResponse, ReferralCode>) {
  const queryClient = useQueryClient();

  return useMutation((referralCode) => postRedeemCode(referralCode), {
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(referralsQueryKeyFn(variables));

      options?.onSuccess?.(data, variables, context);
    },
  });
}
